<!-- Take screenshot for mediaclip -->
<bb-button *ngIf="!isProject" icon="camera" (click)="onScreenshotClick()" data-cy="take-screenshot-button">
	{{ (isCreative ? 'SELECT_END-SCREEN_FROM_VIDEO' : 'SELECT_THUMBNAIL_FROM_VIDEO') | translate }}
</bb-button>

<!-- Opens in overlay -->
<ng-template #screenshotVideoTemplate>
	<bb-screenshot
		(onSave)="onCropSave($event)" (onCancel)="onScreenshotCancel()" [mediaclip]="entity" [select]="'single'">
	</bb-screenshot>
</ng-template>
<ng-template #screenshotImageTemplate>
	<bb-screenshot
		(onSave)="onCropSave($event)" (onCancel)="onScreenshotCancel()" [image]="image">
	</bb-screenshot>
</ng-template>

<div>
	<!-- Looping each cropset in internalThumbnails, e.g. default -->
	<div *ngFor="let cropset of internalThumbnails | keyvalue; let i = index;">
		<div 
			class="thumbnail-cropset" [id]="'cropset-' + cropset.key"
			[style.--width]="(aspectRatioService.aspectRatioRefName[cropset.key]?.aspectratio < 0.5 && cropset.key !== 'default') ? '100px' : '200px'" 
			[style.--widthnr]="(aspectRatioService.aspectRatioRefName[cropset.key]?.aspectratio < 0.5 && cropset.key !== 'default') ? 100 : 200"
			[style.--gap]="(aspectRatioService.aspectRatioRefName[cropset.key]?.aspectratio < 0.5 && cropset.key !== 'default') ? '7px' : '16px'"
		>
			<div class="cropset-header">
				<div class="cropset-name">
					<h3>{{ aspectRatioService.aspectRatioRefName[cropset.key]?.label }}</h3>
					<div class="gray-text">{{ aspectRatioService.aspectRatioRefName[cropset.key]?.value ?? '' }}</div>
				</div>
				<div *ngIf="cropset.key !== 'default' && cropset.key !== clipAspectRatioName" class="delete-cropset gray-text only-on-hover" (click)="deleteCropset(cropset.key)">
					{{ "REMOVE_THUMBNAIL_SET" | translate }}
					<i class="fa fa-trash"></i>
				</div>
				<div class="gray-text only-on-hover" *ngIf="cropset.key === clipAspectRatioName">{{ "DEFAULT_SET" | translate }}</div>
			</div>

			<div class="thumbnail-grid {{cropset.key}}">
				<!-- Upload for this cropset (passes cropset name in customData) -->
				<!-- set height bb-upload in case of no thumbnails yet -->
				<div *ngIf="cropset.key !== 'default'" class="thumbnail-upload"
					[style.grid-column]="aspectRatioService.aspectRatioRefName[cropset.key]?.aspectratio < 0.5 ? '1 / 3' : null"
					[ngStyle]="{
						'width': '200px',
						'min-height': 'calc(( 9 / 16 ) * var(--width))',
						'height': 'calc( ( 1 / ' + ( aspectRatioService.aspectRatioRefName[cropset.key]?.aspectratio ?? (16 / 9)) + ' ) * var(--width))'
					}"
				>
					<bb-upload [onFilter]="filterUploads" [customData]="{ 'cropset': cropset.key }"
						[dropText]="(isCreative? 'DROP_END-SCREEN_OR_UPLOAD' : 'DROP_THUMBNAIL_OR_UPLOAD') | translate">
					</bb-upload>
				</div>

				<!-- Each crop (thumbnail) in the cropset -->
				<div *ngFor="let thumbnail of cropset.value">
					<!-- limit height based on aspectRatio for displaying correct crop -->
					<div class="thumbnail-container" (click)="selectThumbnail(thumbnail)"
						[ngClass]="{'active': thumbnail.crop.main, 'deleted': thumbnail.deleted}"
						[ngStyle]="{ 
							'height': 'calc(( 1 / ' +  thumbnail.crop.cropAspectRatio + ' ) * var(--width)',
							'max-height': thumbnail.crop.cropAspectRatio ? null : '112.5px'
						 }"
					>

						<div class="hover-border"></div>
						<div class="active-marker">
							<i class="far fa-check"></i>
						</div>

						<!-- hover buttons -->
						<div class="thumbnail-buttons" [style.flex-direction]="(aspectRatioService.aspectRatioRefName[cropset.key]?.aspectratio < 0.5 && cropset.key !== 'default') ? 'column' : null">
							<div class="th-button" data-cy="crop-thumbnail-button" [title]="'CROP' | translate" (click)="$event.stopPropagation(); cropImage(thumbnail)">
								<i class="far fa-crop-simple"></i>
							</div>
							<div class="th-button" [title]="'DOWNLOAD' | translate" (click)="$event.stopPropagation(); downloadThumbnail(thumbnail, i)">
								<i class="far fa-file-arrow-down"></i>
							</div>
							<div *ngIf="!thumbnail.deleted" class="th-button" [title]="'DELETE' | translate" (click)="$event.stopPropagation(); deleteThumbnail(thumbnail)">
								<i class="far fa-trash"></i>
							</div>
							<div *ngIf="thumbnail.deleted" class="th-button" [title]="'RESTORE' | translate" (click)="$event.stopPropagation(); undoDeleteThumbnail(thumbnail)">
								<i class="far fa-undo"></i>
							</div>
						</div>

						<div class="img-container">
							<!-- property .data => taken as screenshot or just uploaded -->
							<!-- property .src => thumbnail already in database -->

							<!-- Note using set height instead of Transform scale gave issues that he parent does not know the size (default / free transform issues) -->
							<!-- The height is scaled in increased when the img is cropped. Also taking into account the original size (data) or the requested size (src, this.thumbnailWidth) -->
							<!-- margin-left and margin-top are set according to crop x and y, taking into account the height scaling -->
							<img *ngIf="(thumbnail.src && thumbnail.srcPrefix) || thumbnail.data"
								[attr.src]="thumbnail.data ? thumbnail.data : (thumbnail.srcPrefix + thumbnail.src + '?sesstoken=' + sessionToken)"
								[ngStyle]="{
								'height': 'calc(' + thumbnail.height * (thumbnail.data ? 1 : (thumbnailWidth / thumbnail.width)) + 'px * (100 / ' + thumbnail.crop.width * 100 + ' * (var(--widthnr) / ' + (thumbnail.data ? thumbnail.width : thumbnailWidth) + ')))',
								'margin-left': 'calc(-1 * ' + thumbnail.crop.x + ' *  var(--width) * (100 / ' + thumbnail.crop.width * 100 + '))',
								'margin-top': 'calc(-1 * ' + thumbnail.crop.y * (1 / thumbnail.crop.cropAspectRatio) + ' * var(--width) * (100 / ' + thumbnail.crop.height * 100 + '))'
							}" />
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="!cropsetHasMain[cropset.key] && cropset.value.length > 0">
				<div>
					<span class="warning message">
						<i class="fa fa-warning"></i>&nbsp;{{ 'NO_THUMB_SELECTED_WARNING' | translate }}
					</span>
				</div>
			</div>

		</div>
	</div>
</div>

<div class="button-container">
	<bb-button icon="plus" (click)="addCropSet()" data-cy="add-cropset-button">
		{{ 'ADD_THUMBNAIL_SET' | translate }}
	</bb-button>
</div>

<!-- add cropset overlay -->
<ng-template #cropsetTemplate>
	<div style="display: block; min-width: 320px; width: 75vw; max-width: 420px;" class="add-cropset-overlay">
		<p>{{ "HELP.ADD_THUMBNAIL_SET" | translate}}</p>
		<bb-form-element [form]="form" theme="light-v20" [hideLabel]="true">
			<bb-radio-list [valueOnlyModel]="true" mode="image" name="thumbnail_cropset" [borderColor]="'#D0D5DD'"
				[(ngModel)]="selectedCropset" [options]="cropsetOptions" maxColumns="2">
			</bb-radio-list>
		</bb-form-element>

		<div *ngIf="clipAspectRatioName && internalThumbnails && internalThumbnails[clipAspectRatioName]?.length > 0">
			<bb-form-element [form]="form" [postLabel]="'GENERATE_DEFAULT_THUMBNAILS' | translate">
				<bb-check theme="rb" name="generateDefaultsNewSet" [(ngModel)]="generateDefaultsNewSet" [trueValue]="true" [falseValue]="false">
				</bb-check>
			</bb-form-element>
		</div>

		<div class="action-buttons">
			<bb-button class="cancel" (click)="onCancelAddCropset()">
				{{ 'CANCEL' | translate }}
			</bb-button>
			<bb-button [active]="true" (click)="onSaveAddCropset()" data-cy="add-selected-cropset-button">
				{{ 'ADD' | translate }}
			</bb-button>
		</div>
	</div>
</ng-template>

<div *ngIf="(internalThumbnails | keyvalue).length === 0">
	<div>
		<span class="warning message">
			<i class="fa fa-warning"></i>&nbsp;{{ 'ALL_THUMBS_DELETED_WARNING' | translate }}
		</span>
	</div>
</div>
